import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { select, Store } from "@ngrx/store";
import { Observable, Subscription } from "rxjs";
import { map } from "rxjs/operators";
import { filterNullOrUndefined } from "src/app/@operators/filter-null-or-undefined";
import { InsurerDto, RefLanguageDto } from "src/app/api/models";
import { AppState, getState } from "src/app/state/app.state";
import { environment } from "src/environments/environment";
import { checkInsurerMaintenance } from "../../maintenance/state/maintenance.actions";
import { setTitle } from "../../title/state/title.actions";
import { resetCurrentInsurer, setSelectedInsurer, setSelectedLanguage } from "../../transaction-info/state/transaction-info.actions";
import { getInsurerParamsLoaded } from "../../transaction-info/state/transaction-info.selectors";
import { loadInsurerList, loadInsurerParams, resetInsurer } from "../state/insurer.actions";
import { getInsurerList } from "../state/insurer.selectors";
import { UtilsService } from "src/app/shared/tools/UtilsService";

@Component({
    selector: "app-select-insurer",
    templateUrl: "./select-insurer.component.html",
    styleUrls: ["./select-insurer.component.scss"],
    standalone: false
})
export class SelectInsurerComponent implements OnInit,OnDestroy {
	public allInsurers$: Observable<InsurerDto[]> = this.store.pipe(select(getInsurerList)).pipe(filterNullOrUndefined());
	public insurers$ = this.displayableInsurers();
	public displayableInsurers(): Observable<InsurerDto[]> {
		return this.allInsurers$.pipe(
			map((ic: InsurerDto[]) => ic.filter(i => i.isVisibleForHospitals || i.insurerId == this.insurerParam))
		);
	}

	public properyToDisplay = "insurerNameEN";
	private subs: Subscription[] = [];
	private insurerParam: string;
	private language: RefLanguageDto = null;
	constructor(private store: Store<AppState>, private activatedRoute: ActivatedRoute,private utilsService: UtilsService) {
		this.store.dispatch(resetInsurer());
		this.store.dispatch(resetCurrentInsurer());
		if (environment.kioskMode && window.external.StartProcess)
			window.external.StartProcess();

		this.subs.push(getState(this.store).subscribe(state => {
			this.language = state.transactionInfo.selectedLanguage;
			this.properyToDisplay = "insurerName" + state.transactionInfo.selectedLanguage?.languageCode?.toUpperCase();
		}));

		this.activatedRoute.queryParams.subscribe(p => {
			this.insurerParam = p["setInsurerId"];
		});
		this.store.dispatch(loadInsurerList());
	}

	ngOnInit(): void {
		this.store.dispatch(
			setTitle({
				data: "TITLE_INSURER_SELECTION",
				data2: "TITLE_INSURER_SELECTION_INFO",
			})
		);
	}

	ngOnDestroy(): void {
		this.subs.forEach((_) => _.unsubscribe());
	}

	public onClickInsurer(insurer: InsurerDto) {
		this.store.dispatch(loadInsurerParams({ insurerId: insurer.insurerId, langCode: this.language?.languageCode }));
		this.store.dispatch(checkInsurerMaintenance({ insurerId: insurer.insurerId }));
		if(this.utilsService.validateInsurerForKioskHomeProcess(insurer, this.language)){
			this.subs.push(this.store.pipe(select(getInsurerParamsLoaded))
						.pipe(
							map((insurerParamsLoaded) => {
								if (insurerParamsLoaded == true) {
									this.store.dispatch(setSelectedInsurer({ data: insurer }));
								}
							}
						))
				.subscribe()
			);
		}
	}

	onClickRetour() {
		this.store.dispatch(resetInsurer());
		this.store.dispatch(resetCurrentInsurer());
		this.store.dispatch(setSelectedLanguage(undefined));
	}
}
